export const MINIMUM_PASSWORD_SIZE = 8;
